<template>
  <div class="debugModelSet">
    <Form ref="searchForm" :label-width="110" :model="form">
      <FormItem label="调试模式开关:" style="margin:10px 0;">
        <switchc
          :value="form.debugModel"
          text="on|off"
          style="margin:4px 0 0 0;"
          @change="getAutoVal"
        ></switchc>
      </FormItem>
      <FormItem label="设置终端IP:" style="margin:10px 0;">
        <Input
          type="text"
          style="width:300px;"
          v-model="form.ip"
          placeholder="输入终端IP"
          @on-blur="blurFn"
          on-keyup="this.form.ip = this.form.ip.replace(/，/g, ',')"
          :disabled="!form.debugModel || isEdit"
        />
        <Button
          type="primary"
          style="margin-right: 5px"
          @click="addFn"
          v-if="!isEdit"
          :disabled="form.ip == ''"
          >保存</Button
        >
        <Button
          type="primary"
          style="margin-right: 5px"
          @click="editorFn"
          :disabled="form.ip == ''"
          v-else
          >修改</Button
        >
      </FormItem>
      <FormItem
        label="调试规则管理:"
        style="margin:10px 0;"
        :class="{ unClick: form.ip == '' }"
      >
        <Button
          v-if="debugRule == '' && isEdit2"
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="addNew()"
          >新建调试规则</Button
        >
        <Button
          v-if="debugRule == '' && !isEdit2"
          :disabled="ruleContent == ''"
          type="primary"
          size="small"
          style="margin-right: 5px"
          @click="addNewFn()"
          >提交</Button
        >
        <Table stripe border :columns="columns" :data="debugRule">
          <template slot-scope="{ row }" slot="os">
            <span
              v-for="(item, index) in row.os"
              :key="index"
              v-if="row.os != ''"
            >
              <b v-if="item == '6.1'">Win7、</b>
              <b v-else-if="item == '10.0'">Win10</b>
              <b v-else>--</b>
            </span>
          </template>
          <template slot-scope="{ row, index }" slot="action">
            <Button
              v-if="row.rule != '' && isEdit2"
              type="primary"
              size="small"
              style="margin-right: 5px"
              @click="addRuleFn(0, row.ruleId)"
              >编辑</Button
            >
            <Button
              v-else-if="row.rule != '' && !isEdit2"
              type="primary"
              size="small"
              style="margin-right: 5px"
              @click="addRuleFn(1, row.ruleId)"
              >更新</Button
            >
            <Button
              type="primary"
              size="small"
              style="margin-right: 5px"
              @click="del(row.ruleId)"
              >删除</Button
            >
            <!-- <switchc :value="!row.debugIp==''"
              v-if="row.rule !=''"
              style="margin:4px  4px 0 0;"
                text="on|off"
                class="fr"
                @change="getAutoVal3(row)"
            ></switchc> -->
          </template>
        </Table>
        <Input
          :disabled="isEdit2"
          v-model="ruleContent"
          type="textarea"
          :rows="24"
          placeholder="填写规则内容"
          style="font-family:serif;"
        />
        <Table
          stripe
          border
          v-if="ruleList != ''"
          :columns="columns"
          :data="ruleList"
          class="table2 tac"
        >
          <template slot-scope="{ row }" slot="os">
            <span
              v-for="(item, index) in row.os"
              :key="index"
              v-if="row.os != ''"
            >
              <b v-if="item == '6.1'">Win7、</b>
              <b v-else-if="item == '10.0'">Win10</b>
              <b v-else>--</b>
            </span>
          </template>
          <template slot-scope="{ row }" slot="action">
            <switchc
              :value="row.ruleType == 3"
              text="on|off"
              class="fr"
              v-if="form.ip != ''"
              @change="getAutoVal3(row)"
            ></switchc>
            <span v-else>请设置调试终端IP</span>
          </template>
        </Table>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import switchc from '_c/switch/switch'
import {
  updateDebugRuleByBarId,
  addDebugRuleByBarId,
  onDebugCfgByBarId,
  offDebugCfgByBarId,
  updateDebugIpByBarId,
  getRuleByBarId,
  setDebugRuleByRuleId,
  delDebugRuleByRuleId,
} from '@/requests/debug'
export default {
  props: ['data', 'barId', 'ruleList', 'debugRule'],
  components: {
    switchc,
  },
  watch: {
    debugRule() {
      if (
        this.debugRule != '' &&
        this.debugRule[0] != '' &&
        this.debugRule[0].rule != undefined
      ) {
        this.ruleContent = this.debugRule[0].rule
      }
    },
    data() {
      // if (this.data != '') {
      //   var jsonObj = eval('(' + this.data + ')')
      //   if (jsonObj != null) {
      //     if (
      //       jsonObj.flag != undefined &&
      //       jsonObj.flag != '' &&
      //       jsonObj.flag != null
      //     ) {
      //       if (jsonObj.flag == 1) {
      //         this.form.debugModel = true
      //       } else {
      //         this.form.debugModel = false
      //       }
      //     }
      //     if (
      //       jsonObj.ip != undefined &&
      //       jsonObj.ip != '' &&
      //       jsonObj.ip != null
      //     ) {
      //       this.form.ip = jsonObj.ip
      //       this.isEdit = true
      //     } else {
      //       this.isEdit = false
      //     }
      //   }
      // } else {
      //   this.isEdit = false
      // }
      this.cfgData()
    },
  },
  data() {
    return {
      ruleContent: '',
      isEdit: true,
      isEdit2: true,
      columns: [
        {
          title: '规则ID',
          key: 'ruleId',
          sortable: true,
          align: 'center',
        },
        // {
        //   title: '系统',
        //   key: 'os',
        //   sortable: true,
        //   align: 'center',
        // },
        {
          title: '系统',
          slot: 'os',
          align: 'center',
        },
        // {
        //   title: '调试IP',
        //   key: 'debugIp',
        //   sortable: true,
        //   align: 'center',
        // },
        {
          title: '操作',
          slot: 'action',
          sortable: true,
          align: 'center',
          width: 120,
        },
      ],
      dataSource: [
        {
          ruleId: 999999999,
        },
      ],
      form: {
        debugModel: false,
        ip: '',
        switchValue: false,
      },
      ruleId: '',
      oldVal: '',
    }
  },
  mounted() {
    this.cfgData()
  },
  methods: {
    cfgData() {
      if (this.data != '') {
        var jsonObj = eval('(' + this.data + ')')
        if (jsonObj != null) {
          if (
            jsonObj.flag != undefined &&
            jsonObj.flag != '' &&
            jsonObj.flag != null
          ) {
            if (jsonObj.flag == 1) {
              this.form.debugModel = true
            } else {
              this.form.debugModel = false
            }
          }
          if (
            jsonObj.ip != undefined &&
            jsonObj.ip != '' &&
            jsonObj.ip != null
          ) {
            this.form.ip = jsonObj.ip.toString()
            this.isEdit = true
          } else {
            this.isEdit = false
          }
        }
      } else {
        this.isEdit = false
      }
    },
    blurFn() {
      if (this.form.ip.indexOf('，') != -1) {
        this.form.ip = this.form.ip.replace(/，/g, ',')
      }
    },
    addNewFn() {
      this.addDebugRuleByBarId()
    },
    addNew() {
      this.isEdit2 = false
      this.ruleId = 1000000000
      // this.addDebugRuleByBarId()
    },
    editorFn() {
      this.oldVal = this.form.ip
      this.isEdit = false
      if (this.oldVal != this.form.ip) {
        if (!this.isTrue()) {
          this.updateDebugIpByBarId()
        }
      }
    },
    f_check_IP(val) {
      var re = /^(\d+)\.(\d+)\.(\d+)\.(\d+)$/
      if (re.test(val)) {
        if (
          RegExp.$1 < 256 &&
          RegExp.$2 < 256 &&
          RegExp.$3 < 256 &&
          RegExp.$4 < 256
        ) {
          return true
        }
      }
      window.$Message.show({
        title: '提示',
        type: 'error',
        msg: '输入的IP不对，请重新核对',
      })
      return false
    },
    isTrue() {
      let flag = false
      if (this.form.ip.indexOf(',') != -1) {
        let newArr = this.form.ip.split(',')
        newArr.forEach((element) => {
          console.log(this.f_check_IP(element))
          if (!this.f_check_IP(element)) {
            flag = true
          }
        })
      } else if (this.form.ip.indexOf('-') != -1) {
        let newArr = this.form.ip.split('-')
        newArr.forEach((element) => {
          console.log(this.f_check_IP(element))
          if (!this.f_check_IP(element)) {
            flag = true
          }
        })
      } else {
        if (!this.f_check_IP(this.form.ip)) {
          flag = true
        }
      }
      return flag
    },
    addFn() {
      if (!this.isTrue()) {
        this.updateDebugIpByBarId()
      }
    },
    getAutoVal(val) {
      this.form.debugModel = val
      if (val) {
        this.isEdit = false
        this.onDebugCfgByBarId()
      } else {
        this.offDebugCfgByBarId()
      }
      this.$emit('changeFn')
    },
    async onDebugCfgByBarId() {
      let res = await onDebugCfgByBarId({
        id: this.barId,
      })
      if (res.code != 200) {
        this.form.debugModel = false
        this.$emit('changeFn')
      }
    },
    async offDebugCfgByBarId() {
      let res = await offDebugCfgByBarId({
        id: this.barId,
      })
      if (res.code != 200) {
        this.form.debugModel = true
        this.$emit('changeFn')
      }
    },
    async updateDebugIpByBarId() {
      let res = await updateDebugIpByBarId(this.barId, this.form.ip)
      console.log(res)
      if (res.code == 200) {
        this.isEdit = true
        this.$emit('changeFn')
      }
    },
    async getRuleByBarId() {
      let res = await getRuleByBarId(this.barId)
      console.log(res)
    },
    async setDebugRuleByRuleId() {
      let res = await setDebugRuleByRuleId(this.barId, this.ruleId)
      console.log(res)
      this.$emit('changeFn')
    },
    async delDebugRuleByRuleId() {
      let res = await delDebugRuleByRuleId(this.barId, this.ruleId)
      this.$emit('changeFn')
    },
    getAutoVal3(val) {
      this.ruleId = val.ruleId
      if (val.ruleType == 2) {
        this.setDebugRuleByRuleId()
      } else {
        this.delDebugRuleByRuleId()
      }
    },
    del(val) {
      this.ruleId = val
      this.delDebugRuleByRuleId()
    },
    async addDebugRuleByBarId() {
      let res = await addDebugRuleByBarId(
        this.barId,
        this.ruleId,
        this.ruleContent
      )
      console.log(res)
      if (res.code == 200) {
        this.isEdit2 = true
        this.$emit('changeFn')
      } else {
        window.$Message.show({
          title: '提示',
          type: 'error',
          msg: res.msg,
        })
      }
    },
    async updateDebugRuleByBarId() {
      let res = await updateDebugRuleByBarId(
        this.barId,
        this.ruleId,
        this.ruleContent
      )
      if (res.code == 200) {
        this.isEdit2 = true
        this.$emit('changeFn')
      } else {
        window.$Message.show({
          title: '提示',
          type: 'error',
          msg: res.msg,
        })
      }
    },
    addRuleFn(key, val) {
      this.ruleId = val
      this.isEdit2 = false
      if (key == 1) {
        this.updateDebugRuleByBarId()
      } else if (key == 2) {
        this.addDebugRuleByBarId()
      }
    },
  },
}
</script>
<style>
.unClick {
  pointer-events: none;
  opacity: 0.6;
}
.table2 thead {
  display: none;
}
.ivu-table-header thead tr th {
  padding: 0;
}
</style>
